import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RegisterIAService {

  ia_orgname: any;
  ia_username: any;
  ia_password: any;
  ia_confpassword: any;
  ia_mobnum: any;
  ia_email: any;
  ia_mobotp: any;
  ia_emailotp: any;
  ia_designation: any;
  ia_focussector: any;
  ia_district: any;
  ia_dic: any;
  ia_address: any;
  ia_intervention: any;
  ia_bankname: any;
  ia_accnum: any;
  ia_ifsccode: any;
  ia_cin: any;
  ia_orgpan: any;
  ia_regdate: any;

  constructor() {
    this.ia_orgname = '';
    this.ia_username = '';
    this.ia_password = '';
    this.ia_confpassword = '';
    this.ia_mobnum = '';
    this.ia_email = '';
    this.ia_mobotp = '';
    this.ia_emailotp = '';
    this.ia_designation = '';
    this.ia_focussector = '';
    this.ia_district = '';
    this.ia_dic = '';
    this.ia_address = '';
    this.ia_intervention = '';
    this.ia_bankname = '';
    this.ia_accnum = '';
    this.ia_ifsccode = '';
    this.ia_cin = '';
    this.ia_orgpan = '';
    this.ia_regdate = '';
  }

  getIADetails() {
    return this.ia_orgname, this.ia_username, this.ia_password, this.ia_confpassword,
      this.ia_mobnum,
      this.ia_email,
      this.ia_mobotp,
      this.ia_emailotp,
      this.ia_designation,
      this.ia_focussector,
      this.ia_district,
      this.ia_dic,
      this.ia_address,
      this.ia_intervention,
      this.ia_bankname,
      this.ia_accnum,
      this.ia_ifsccode,
      this.ia_cin,
      this.ia_orgpan,
      this.ia_regdate;
  }

  setIADetails(s_orgname: string, s_username: string, s_password: string, s_confpwd: string,
    s_mobnum: number, s_email: string, s_mobotp: number, s_emailotp: number,
    s_designation: string, s_focussector: string, s_district: string, s_dic: string, s_address: string,
    s_intervention: string, s_bankname: string, s_accnum: number, s_ifsccode: string, s_cin: string, s_orgpan: string,
    s_regdate: string) {
    this.ia_orgname = s_orgname;
    this.ia_username = s_username;
    this.ia_password = s_password;
    this.ia_confpassword = s_confpwd;
    this.ia_mobnum = s_mobnum;
    this.ia_email = s_email;
    this.ia_mobotp = s_mobotp;
    this.ia_emailotp = s_emailotp;
    this.ia_designation = s_designation;
    this.ia_focussector = s_focussector;
    this.ia_district = s_district;
    this.ia_dic = s_dic;
    this.ia_address = s_address;
    this.ia_intervention = s_intervention;
    this.ia_bankname = s_bankname
    this.ia_accnum = s_accnum;
    this.ia_ifsccode = s_ifsccode;
    this.ia_cin = s_cin;
    this.ia_orgpan = s_orgpan;
    this.ia_regdate = s_regdate;
  }
}
